import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=70d94f72"
import script from "@/scripts/adminManager/promotion/promotionDetail.js?vue&type=script&lang=js&external"
export * from "@/scripts/adminManager/promotion/promotionDetail.js?vue&type=script&lang=js&external"
import style0 from "./PromotionDetail.vue?vue&type=style&index=0&id=70d94f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports